<template>
    <div class="container">
        <router-view></router-view>

        <h2 class="pt-5 mb-5 text-center">Dashboard</h2>

        <iframe width="100%" style="min-height: 500px" src="https://workitaround.clicdata.com/b/jadRo4wQpMrh"></iframe>
    </div>
</template>

<script>
  export default {
    name: 'DataDashboard',

    methods: {
    },
    data() {
      return {};
    },
    computed: {
    },
    components: {
    }
  };

</script>
